(() => {
  const syncNavigation = (swiper, navigation, previousButton, nextButton) => {
    const isLocked = Boolean(swiper.isLocked);

    navigation.hidden = isLocked;
    previousButton.disabled = isLocked || swiper.isBeginning;
    nextButton.disabled = isLocked || swiper.isEnd;
    previousButton.setAttribute('aria-disabled', String(previousButton.disabled));
    nextButton.setAttribute('aria-disabled', String(nextButton.disabled));
  };

  const initCarousel = (section) => {
    if (typeof Swiper === 'undefined') return;

    const carousel = section.querySelector('.js-swiper-product-carousel');
    const scrollbar = section.querySelector('.js-product-carousel-swiper-scrollbar');
    const previousButton = section.querySelector('.js-product-carousel-arrow-prev');
    const nextButton = section.querySelector('.js-product-carousel-arrow-next');
    const navigation = section.querySelector('.product-carousel_nav-tools');

    if (!carousel || !scrollbar || !previousButton || !nextButton || !navigation || carousel.swiper) return;

    const isSeasonal = carousel.dataset.seasonal === 'true';
    const seasonalBreakpoints = {
      750: { slidesPerView: 2.5, spaceBetween: 16, slidesOffsetAfter: 0 },
      990: { slidesPerView: 3.25, spaceBetween: 20, slidesOffsetAfter: 0 },
      1100: { slidesPerView: 4, spaceBetween: 24, slidesOffsetAfter: 0 },
    };
    const defaultBreakpoints = {
      750: { slidesPerView: 1.2, spaceBetween: 20, slidesOffsetAfter: 0 },
      990: { slidesPerView: 2, spaceBetween: 24, slidesOffsetAfter: 0 },
      1100: { slidesPerView: 3, spaceBetween: 24, slidesOffsetAfter: 0 },
    };

    const swiper = new Swiper(carousel, {
      slidesPerView: isSeasonal ? 2.05 : 1.2,
      spaceBetween: isSeasonal ? 12 : 20,
      slidesOffsetAfter: isSeasonal ? 16 : 20,
      watchOverflow: true,
      scrollbar: {
        el: scrollbar,
        draggable: true,
      },
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Productos anteriores',
        nextSlideMessage: 'Productos siguientes',
        firstSlideMessage: 'Este es el primer producto',
        lastSlideMessage: 'Este es el último producto',
      },
      breakpoints: isSeasonal ? seasonalBreakpoints : defaultBreakpoints,
      on: {
        init(instance) {
          syncNavigation(instance, navigation, previousButton, nextButton);
        },
        slideChange(instance) {
          syncNavigation(instance, navigation, previousButton, nextButton);
        },
        resize(instance) {
          syncNavigation(instance, navigation, previousButton, nextButton);
        },
        lock(instance) {
          syncNavigation(instance, navigation, previousButton, nextButton);
        },
        unlock(instance) {
          syncNavigation(instance, navigation, previousButton, nextButton);
        },
      },
    });

    syncNavigation(swiper, navigation, previousButton, nextButton);
  };

  const initCarousels = (scope = document) => {
    if (scope.matches && scope.matches('.js-get-section')) initCarousel(scope);
    scope.querySelectorAll('.js-get-section').forEach(initCarousel);
  };

  if (window.morkasProductCarouselInit) {
    window.morkasProductCarouselInit();
    return;
  }

  window.morkasProductCarouselInit = initCarousels;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCarousels(), { once: true });
  } else {
    initCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCarousels(event.target);
  });
})();
